/**
 * #619: черновик тренировки устарел — на эту дату уже сохранена программная
 * тренировка. Сервер второй программной записи на дату не примет (409
 * DAY_TAKEN), так что такой черновик — остаток уже завершённой тренировки:
 * экран после сохранения не ушёл на итог и успел записать черновик заново.
 * Раньше дневник считал черновик важнее записи и звал «Продолжить», а каждое
 * «Завершить» получало «уже сохранена» — клиент не мог «завершить» тренировку.
 */
export function isWorkoutDraftStale(
  draft: { date: string; programDayId?: string | null } | null | undefined,
  savedEntry: { programDayId?: string | null } | null | undefined,
): boolean {
  return !!draft && !!draft.programDayId && !!savedEntry?.programDayId
}
